// import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SvgIcon, IconButton } from '@mui/material';
import { MdOutlineArrowBackIosNew } from 'react-icons/md';

// import { addEmployee } from 'redux/usersPermissions';
import { newEmployee } from 'views/ProviderProfile/types';
import PersonForm from '../PersonForm/PersonForm';
import api from 'api';
import { useState } from 'react';
import styles from './AddUserPage.module.scss';
import AlertMessage, { AlertObj } from 'components/common/alert';

const AddUserPage = () => {
    const navigate = useNavigate();
    const [isShowingAlert, setShowingAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState<AlertObj>({ type: 'info', value: '' });

    // const dispatch = useDispatch();

    const goBack = () => {
        navigate(-1);
    };

    const initialPersonValue: newEmployee = {
        // service_provider_id,
        firstname: '',
        lastname: '',
        middlename: '',
        email: '',
        phone_number: '',
        role: '',
    };

    const handleFormData = async (empData: newEmployee) => {
        // await saveProgress('ImmigrationProfessional', empData);
        const preparedData = {
            email: empData.email,
            firstname: empData.firstname,
            middlename: empData.middlename,
            lastname: empData.lastname,
            role: empData.role,
            phone_number: empData.phone_number,
        };
        try {
            const request = await api.immigrationProfessional.post(preparedData);
            if (request.status === 200 || request.status === 201) {
                setAlertMessage({ type: 'success', value: 'Collaborator successfully added!' });
                setShowingAlert(true);
            }
        } catch {
            setAlertMessage({ type: 'error', value: 'Something went wrong.' });
            setShowingAlert(true);
        }

        // const emulatedRequest: Employee = { ...empData, id: Date.now().toString() };
        // dispatch(addEmployee(emulatedRequest));

        // setTimeout(() => {
        //     navigate('/account/permissions');
        // }, 1000);
    };
    const Alert = (
        <AlertMessage
            type={alertMessage?.type}
            text={alertMessage?.value}
            open={isShowingAlert}
            onClose={() => setShowingAlert(false)}
        ></AlertMessage>
    );

    return (
        <div className={styles.root}>
            <IconButton
                onClick={() => goBack()}
                style={{
                    fontFamily: 'Assistant, sans-serif',
                    fontSize: '15px',
                    color: '#282828',
                    height: '36px',
                    width: '36px',
                    borderRadius: '50%',
                    boxSizing: 'border-box',
                }}
            >
                <SvgIcon
                    style={{ width: '9px', height: '15px' }}
                    viewBox="7 3 12 19"
                    component={MdOutlineArrowBackIosNew}
                />
            </IconButton>
            {Alert}
            <h1 className={styles.title}>Invite user to team</h1>

            <PersonForm
                initialFormValue={initialPersonValue}
                btnName="Send Invitation"
                getFormData={handleFormData}
            />
        </div>
    );
};

export default AddUserPage;
